import { RootState } from "store/index";

const selectRightPanelState = (state: RootState) => state.rightPanel;

export { selectRightPanelState };
